import React from 'react';
import PropTypes from 'prop-types';
import { Trash2, Edit2, Check } from 'lucide-react';

import { UserRole, VerificationStatus } from 'utils/bankStatements';
import { useToast } from './ui/toast';

const TransactionActions = ({
  transaction,
  accountId,
  onDelete,
  onEdit,
  onAccept,
  userRole,
}) => {
  const { showToast } = useToast();

  const handleDeleteClick = async (e) => {
    e.stopPropagation();
    if (
      window.confirm('Are you sure you want to delete this transaction? This action cannot be undone.')
    ) {
      try {
        await onDelete(transaction.id);
      } catch (error) {
        showToast('Failed to delete transaction', 'error');
      }
    }
  };

  const handleEditClick = (e) => {
    e.stopPropagation();
    onEdit(e, transaction.id, accountId);
  };

  const handleAcceptClick = (e) => {
    e.stopPropagation();
    onAccept(e, transaction, accountId);
  };

  const buttonStyles = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '28px',
    height: '28px',
    border: '1px solid #E5E7EB',
    borderRadius: '4px',
    marginLeft: '4px',
    backgroundColor: '#FFFFFF',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
  };

  if (userRole === UserRole.User) {
    if (transaction.verificationStatus === VerificationStatus.NeedsReview) {
      return (
        <div
          className="flex items-center justify-center gap-1"
          onClick={e => e.stopPropagation()}
        >
          <button
            type="button"
            onClick={handleEditClick}
            title="Edit Transaction"
            style={buttonStyles}
            className="hover:bg-gray-50 hover:border-gray-300"
          >
            <Edit2 aria-label="Edit Transaction" className="w-4 h-4 text-gray-600" />
          </button>
          <button
            type="button"
            onClick={handleAcceptClick}
            title="Mark as verified"
            style={buttonStyles}
            className="hover:bg-gray-50 hover:border-gray-300"
          >
            <Check aria-label="Mark as verified" className="w-4 h-4 text-emerald-600" />
          </button>
        </div>
      );
    }
    return null;
  }

  return (
    <div
      className="flex items-center justify-center gap-1"
      onClick={e => e.stopPropagation()}
    >
      <button
        type="button"
        onClick={handleDeleteClick}
        title="Delete Transaction"
        style={buttonStyles}
        className="hover:bg-red-50 hover:border-red-300"
      >
        <Trash2 aria-label="Delete Transaction" className="w-4 h-4 text-red-600" />
      </button>
      <button
        type="button"
        onClick={handleEditClick}
        title="Edit Transaction"
        style={buttonStyles}
        className="hover:bg-gray-50 hover:border-gray-300"
      >
        <Edit2 aria-label="Edit Transaction" className="w-4 h-4 text-gray-600" />
      </button>
      <button
        type="button"
        onClick={handleAcceptClick}
        title="Mark as verified"
        style={buttonStyles}
        className="hover:bg-emerald-50 hover:border-emerald-300"
      >
        <Check aria-label="Mark as verified" className="w-4 h-4 text-emerald-600" />
      </button>
    </div>
  );
};

TransactionActions.propTypes = {
  transaction: PropTypes.object.isRequired,
  accountId: PropTypes.number.isRequired,
  onDelete: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onAccept: PropTypes.func.isRequired,
  userRole: PropTypes.string.isRequired,
};

export default TransactionActions;
